/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_Feature_3Inputs */

const en_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep + Salary data`)
};

const de_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch-Vorbereitung + Gehaltsdaten`)
};

const fr_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation d'entretien + Données salariales`)
};

const es_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación de entrevista + Datos salariales`)
};

const it_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione colloqui + Dati salariali`)
};

const nl_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatievoorbereiding + Salarisgegevens`)
};

const pl_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie do rozmowy kwalifikacyjnej + Dane dotyczące wynagrodzenia`)
};

const fi_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastattelun valmistelu + Palkkatiedot`)
};

const da_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewforberedelse + Lønsdata`)
};

const sv_settings_student_feature_3 = /** @type {(inputs: Settings_Student_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervju förberedelse + Lönedata`)
};

/**
* | output |
* | --- |
* | "Interview prep + Salary data" |
*
* @param {Settings_Student_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_feature_3 = /** @type {((inputs?: Settings_Student_Feature_3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_Feature_3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_feature_3(inputs)
	if (locale === "fr") return fr_settings_student_feature_3(inputs)
	if (locale === "es") return es_settings_student_feature_3(inputs)
	if (locale === "it") return it_settings_student_feature_3(inputs)
	if (locale === "nl") return nl_settings_student_feature_3(inputs)
	if (locale === "pl") return pl_settings_student_feature_3(inputs)
	if (locale === "fi") return fi_settings_student_feature_3(inputs)
	if (locale === "da") return da_settings_student_feature_3(inputs)
	if (locale === "sv") return sv_settings_student_feature_3(inputs)
	return en_settings_student_feature_3(inputs)
});